import { html, ref } from '@microsoft/fast-element';
import type { BuyerAnalytics } from './buyer-analytics';

export const BuyerAnalyticsTemplate = html<BuyerAnalytics>`
  <analytics-wizard></analytics-wizard>
`;
